import React, { useState, useEffect } from 'react';
import { addToCart } from "frontend/js/useShopifyCart";
import ImageComponent from "@project-stories/elements/Image/Image";

const ProductSuitKit = ({ settings }) => {
  const metafields = settings.metafields || {};
  const referencedProducts = [
    { key: "matching_jacket", label: "Jacket", product: metafields?.matching_jacket },
    { key: "matching_vest", label: "Waistcoat", product: metafields?.matching_vest },
    { key: "matching_trouser", label: "Trousers", product: metafields?.matching_trouser }
  ].filter(p => p.product && p.product.featured_image);

  const [selectedItems, setSelectedItems] = useState(() => {
    const initial = {};
    referencedProducts.forEach(ref => {
      initial[ref.label] = true;
    });
    return initial;
  });

  const [selectedSizes, setSelectedSizes] = useState(() => {
    const initial = {};
    referencedProducts.forEach(ref => {
      initial[ref.label] = ref.product.variants?.[0]?.id || "";
    });
    return initial;
  });

  const handleCheckboxChange = (label) => {
    setSelectedItems(prev => ({ ...prev, [label]: !prev[label] }));
  };

  const handleSizeChange = (label, sizeId) => {
    setSelectedSizes(prev => ({ ...prev, [label]: Number(sizeId) }));
  };

  const handleSuitKitAdd = async () => {
    const itemsToAdd: { id: number | string; quantity: number; properties: Object }[] = [];

    referencedProducts.forEach(({ label }) => {
      if (selectedItems[label]) {
        const selectedVariantId = selectedSizes[label];
        if (selectedVariantId) {
          itemsToAdd.push({
            id: selectedVariantId,
            quantity: 1,
            properties: {
              _suitKit: true
            }
          });
        }
      }
    });

    if (itemsToAdd.length > 0) {
      try {
        await addToCart({ items: itemsToAdd });
        console.log('Selected suit kit items added to cart');
      } catch (error) {
        console.error('Error adding items to cart:', error);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("add-suit-kit-to-cart", handleSuitKitAdd);
    return () => {
      document.removeEventListener("add-suit-kit-to-cart", handleSuitKitAdd);
    };
  }, [referencedProducts, selectedItems, selectedSizes]);

  return (
    <div className="pb-4 suit-kit-size-selector lg:pb-8">
      <div className="flex flex-col gap-8">
        {referencedProducts.map(({ label, product }, index) => (
          <div key={index} className="flex items-center gap-4">
            <div className="flex items-center w-full gap-6 flex-nowrap">
              <a href={product.handle}>
                <ImageComponent
                  imageUrl={product.featured_image}
                  alt={label}
                  classes="w-[75px] h-28 object-cover"
                />
              </a>
              <div className="flex flex-col w-full">
                <div className="flex items-center justify-between gap-2 py-2 lg:py-0">
                  <div>
                    <input
                      type="checkbox"
                      className="!w-6 !h-6 mr-2 border-black rounded"
                      checked={selectedItems[label]}
                      onChange={() => handleCheckboxChange(label)}
                    />
                    <span className="text-black b2">{label} Size</span>
                  </div>
                  <div>
                    <span className="ml-auto text-[#54565A] bcp">
                      ${(product.price / 100).toFixed(2)}
                    </span>
                  </div>
                </div>
                <select
                  className="w-full b2 mt-[15px] border-b border-[#00263E] text-[#00263E] focus:outline-none"
                  value={selectedSizes[label]}
                  onChange={(e) =>
                    handleSizeChange(label, e.target.value)
                  }
                >
                  {product.variants?.map((variant) => (
                    <option
                      key={variant.id}
                      value={variant.id}
                      disabled={!variant.available}
                    >
                      {variant.option2}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductSuitKit;